import CustomField from "components/Common/CustomField"
import CustomLabel from "components/Common/CustomLabel"
import { ErrorMessage, Field, Form, Formik } from "formik"
import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import {
  getDropdownData,
  getSystemNationalities,
} from "store/actions/commonAction"
import {
  createInterviewSchedule,
  getInterviewScheduleDetails,
  updateInterviewSchedule,
} from "store/actions/interviewsAction"
import { showAlert } from "store/reducers/alertReducer"
import * as Yup from "yup"
import MatchedCandidates from "./MatchedCandidates"
import Select from "react-select"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css" // Choose a theme
import {
  arabicNameOrNumberPattern,
  formatDateForAPI,
  getLocalizedName,
} from "components/Common/Utils"
import { usePermissions } from "hooks"
import BackButton from "components/Shared/BackButton"
import Spinners from "components/Shared/Spinners"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import moment from "moment/moment"
import CustomSingleSelect from "components/Shared/CustomSingleSelect"

const today = new Date().toISOString().split("T")[0] // Get today's date in YYYY-MM-DD

const initialValues = {
  title: "",
  title_ar: "",
  description: "",
  description_ar: "",
  start_date: today, // Default to today
  end_date: today, // Default to today
  start_time: "",
  end_time: "",
  total_capacity: "",
  city_ids: [],
  specialization_id: "",
  specialization_ids: [],
  gender: "",
  is_saudi: "",
  education_qualification_id: "",
  education_qualification_ids: [],
  employee_experience: "",
  employee_experience_as_per_document: "",
  national_ids: "",
  nationality_ids: [],
  note: "",
  is_pool: false,
  positions_ids: [],
  is_auto_accepted_invitation: false,
}

const CreateInterviewSchedule = ({ mode }) => {
  const { loading, isLoading, totalCount, loading2, interviewScheduleDetails } =
    useSelector(state => state.Interviews)
  const { dropdownData, systemNationalities } = useSelector(
    state => state.Common
  )
  const [modal, setModal] = useState(false)
  const [notification_message, setNotification_message] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const toggleModal = () => setIsModalOpen(!isModalOpen)
  const [isScheduledCreated, setIsScheduledCreated] = useState(false)
  const [description, setDescription] = useState("")
  const [description_ar, setDescriptionAr] = useState("")
  const [prevTotalCapacity, setPrevTotalCapacity] = useState(0)
  const [minAge, setMinAge] = useState()
  const [maxAge, setMaxAge] = useState()

  const toggle = () => setModal(!modal)

  const navigate = useNavigate()
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const dispatch = useDispatch()
  const { permissions, showAll } = usePermissions("interview_schedule")

  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const genders = [
    {
      label: t("Select Option"),
      value: "",
    },
    {
      label: t("Male"),
      value: "male",
    },
    {
      label: t("Female"),
      value: "female",
    },
  ]

  const experiences = [
    {
      label: t("Select Option"),
      value: "",
    },
    {
      label: t("Experienced"),
      value: "1",
    },
    {
      label: t("New"),
      value: "2",
    },
  ]

  useEffect(() => {
    const fetchDropdownApi = () => {
      const payload = {
        type: "all",
      }
      dispatch(getDropdownData(payload))
      dispatch(getSystemNationalities())
    }

    const getDetails = () => {
      dispatch(getInterviewScheduleDetails(id))
    }

    fetchDropdownApi()
    mode === "update" && getDetails()
  }, [])

  const [formValues, setFormValues] = useState(initialValues)
  const [selectedCandidates, setSelectedCandidates] = useState([])
  const [selectAllPages, setSelectAllPages] = useState(true)
  const [selectCurrentPage, setSelectCurrentPage] = useState(false)
  const [uncheckedIds, setUncheckedIds] = useState([])

  useEffect(() => {
    if (!loading && interviewScheduleDetails && mode === "update") {
      const {
        title,
        title_ar,
        description,
        description_ar,
        start_date,
        end_date,
        start_time,
        end_time,
        total_capacity,
        total_user_enrolled,
        total_available_seat,
        status,
        gender,
        is_saudi,
        city,
        nationality,
        education_qualification,
        specialization,
        employee_experience,
        employee_experience_as_per_document0,
        positions_ids,
        is_pool,
        is_auto_accepted_invitation,
      } = interviewScheduleDetails

      setPrevTotalCapacity(total_capacity)
      setDescription(description)
      setDescriptionAr(description_ar)
      setFormValues(prev => ({
        title,
        title_ar,
        positions_ids: [],
        start_date,
        end_date,
        start_time,
        end_time,
        total_capacity,
        city_ids: [],
        specialization_id: "",
        gender,
        is_saudi,
        education_qualification_id: "",
        employee_experience: "",
        employee_experience_as_per_document: "",
        national_ids: "",
        nationality_ids: [],
        specialization_ids: [],
        education_qualification_ids: [],
        note: "",
        is_pool,
        is_auto_accepted_invitation,
      }))
    }
  }, [mode, interviewScheduleDetails])

  const validationSchema = Yup.object().shape({
    title: Yup.string().required(`${t("Field is required")}`),
    title_ar: Yup.string()
      .required(`${t("Field is required")}`)
      .matches(arabicNameOrNumberPattern, t("Only Arabic letters are allowed")),
    // description: Yup.string().required("Field is required"),
    // description_ar: Yup.string().required("Field is required"),
    // start_date: Yup.date()
    //   .required(`${t("Field is required")}`)
    //   .min(
    //     new Date(new Date().setHours(0, 0, 0, 0)),
    //     t("Date must be today or later")
    //   )
    //   .test(
    //     "is-valid-date",
    //     t("Invalid date"),
    //     value => value instanceof Date && !isNaN(value)
    //   ),
    // end_date: Yup.date().required(`${t("Field is required")}`),
    start_date:
      mode === "update"
        ? Yup.date()
        : Yup.date()
            .required(`${t("Field is required")}`)
            .min(
              new Date(new Date().setHours(0, 0, 0, 0)),
              t("Date must be today or later")
            )
            .test(
              "is-valid-date",
              t("Invalid date"),
              value => value instanceof Date && !isNaN(value)
            ),

    end_date: Yup.date()
      .required(`${t("Field is required")}`)
      .test(
        "is-after-start-date",
        t("End date must be today or later"),
        function (endDate) {
          const { start_date } = this.parent
          return (
            !start_date || !endDate || new Date(endDate) >= new Date(start_date) // Allow same date
          )
        }
      ),
    // .min(
    //   new Date(new Date().setHours(0, 0, 0, 0)),
    //   t("Date must be today or later")
    // )
    // .test(
    //   "is-valid-date",
    //   t("Invalid date"),
    //   value => value instanceof Date && !isNaN(value)
    // ),

    start_time: Yup.string().required(`${t("Field is required")}`),
    // .test(
    //   "is-future-time-if-today",
    //   t("Start time must be in the future if today"),
    //   function (start_time) {
    //     const { start_date } = this.parent
    //     if (!start_date || !start_time) return true // Skip validation if either field is empty

    //     const selectedDate = new Date(start_date)
    //     const today = new Date()

    //     // Check if selected date is today
    //     const isToday =
    //       selectedDate.getFullYear() === today.getFullYear() &&
    //       selectedDate.getMonth() === today.getMonth() &&
    //       selectedDate.getDate() === today.getDate()

    //     if (isToday) {
    //       // Convert current time to HH:MM (24-hour format)
    //       const nowHours = today.getHours()
    //       const nowMinutes = today.getMinutes()
    //       const currentTime = nowHours * 60 + nowMinutes // Convert to total minutes

    //       // Convert start_time to total minutes for comparison
    //       const [hours, minutes] = start_time.split(":").map(Number)
    //       const enteredTime = hours * 60 + minutes // Convert to total minutes

    //       return enteredTime > currentTime // Must be a future time
    //     }
    //     return true
    //   }
    // ),
    end_time: Yup.string().required(`${t("Field is required")}`),
    // .test(
    //   "is-after-start",
    //   t("End time must be after Start time"),
    //   function (end_time) {
    //     const { start_time } = this.parent
    //     return start_time && end_time ? start_time < end_time : true
    //   }
    // ),
    total_capacity: Yup.number()
      .required(`${t("Field is required")}`)
      .positive()
      .integer()
      .test(
        "is-not-decreasing",
        t("Total capacity cannot be less than the previous value"),
        function (value) {
          if (mode === "update" && prevTotalCapacity !== undefined) {
            return value >= prevTotalCapacity
          }
          return true
        }
      ),
    // city_ids: Yup.string().required("Field is required"),
    // specialization_id: Yup.string().required("Field is required"),
    // gender: Yup.string().required("Field is required"),
    // is_saudi: Yup.string().required("Field is required"),
    // employee_experience: Yup.string().required("Field is required"),
    // education_qualification_id: Yup.string().required("Field is required"),
    national_ids: Yup.string().matches(
      /^(\d+(,\s?\d+)*)?$/,
      t("Invalid format. Use only numbers separated by commas.")
    ),
  })

  const handleOnSubmit = values => {
    if (
      !isModalOpen && // Prevent duplicate popups
      values.is_pool &&
      values.national_ids && // Show popup only if both exist
      mode !== "update"
    ) {
      const startDate = formatDateForAPI(values?.start_date)
      setNotification_message(
        `'لديك فترة زمنية متاحة للمقابلة في ${startDate}. يرجى تسجيل الدخول إلى حسابك لتأكيد الفترة الزمنية وحجز المقابلة.'`
      )
      setIsModalOpen(true)
      return // Stop further execution
    } else if (!isModalOpen && !values.is_pool && mode !== "update") {
      // Show popup if is_pool is false
      const startDate = formatDateForAPI(values?.start_date)
      setNotification_message(
        `'لديك فترة زمنية متاحة للمقابلة في ${startDate}. يرجى تسجيل الدخول إلى حسابك لتأكيد الفترة الزمنية وحجز المقابلة.'`
      )
      setIsModalOpen(true)
      return
    }
    // if (isModalOpen) {
    setIsModalOpen(false)
    if (
      values.employee_experience.value === "1" &&
      values.positions_ids.length === 0
    ) {
      return dispatch(
        showAlert({
          text: t("Please select at least one position"),
          type: "error",
        })
      )
    }

    const formattedNationalIds = [
      ...new Set(
        values.national_ids
          .split(",")
          .map(id => id.trim())
          .filter(id => id !== "") // Remove empty values
      ),
    ]

    const updatedCitiesId = values?.city_ids?.map(item => item.value) || []
    const updatedPositionsId =
      values?.positions_ids?.map(item => item.value) || []
    const updatedSpecializationIds =
      values?.specialization_ids?.map(item => item.value) || []
    const updatedNationlityIds =
      values?.nationality_ids?.map(item => item.value) || []
    const updatedEducationQualificationsIds =
      values?.education_qualification_ids?.map(item => item.value) || []

    let ageRange = null

    if (minAge && !maxAge) {
      return dispatch(
        showAlert({
          text: t("Please enter max age"),
          type: "error",
        })
      )
    }

    if (!minAge && maxAge) {
      return dispatch(
        showAlert({
          text: t("Please enter min age"),
          type: "error",
        })
      )
    }

    if (minAge && maxAge) {
      if (minAge > maxAge) {
        return dispatch(
          showAlert({
            text: t("Min age must be less than max age"),
            type: "error",
          })
        )
      }
      if (minAge < 0 || maxAge < 0) {
        return dispatch(
          showAlert({
            text: t("Age must be greater than 0"),
            type: "error",
          })
        )
      }

      if (minAge > 100 || maxAge > 100) {
        return dispatch(
          showAlert({
            text: t("Age must be less than 100"),
            type: "error",
          })
        )
      }

      if (minAge && maxAge) {
        ageRange = {
          min: minAge,
          max: maxAge,
        }
      }
    }
    const updatedNationalIds = formattedNationalIds?.length
      ? selectedCandidates
      : selectAllPages
      ? []
      : selectedCandidates

    const updatedValues = {
      ...values,
      employee_experience: values?.employee_experience?.value,
      gender: values?.gender?.value,
      national_ids: updatedNationalIds,
      exclude_national_ids: uncheckedIds,
      city_ids: updatedCitiesId,
      start_date: formatDateForAPI(values?.start_date),
      end_date: formatDateForAPI(values?.end_date),
      notification_message,
      description,
      description_ar,
      positions_ids: updatedPositionsId,
      specialization_ids: updatedSpecializationIds,
      nationality_ids: updatedNationlityIds,
      education_qualification_ids: updatedEducationQualificationsIds,
    }

    if (ageRange) {
      updatedValues.min_age = ageRange.min
      updatedValues.max_age = ageRange.max
    }

    if (mode === "create") {
      dispatch(createInterviewSchedule(updatedValues))
        .then(action => {
          const { statusCode, success, message } = action?.payload
          if (statusCode === 200 && success) {
            dispatch(showAlert({ text: message, type: "success" }))
            navigate(-1)
          } else {
            dispatch(showAlert({ text: message, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "update") {
      const {
        title,
        title_ar,
        start_date,
        end_date,
        start_time,
        end_time,
        note,
        total_capacity,
      } = values || {}

      const updatePayload = {
        title,
        title_ar,
        description,
        description_ar,
        start_date: formatDateForAPI(start_date),
        end_date: formatDateForAPI(end_date),
        start_time,
        end_time,
        note,
        total_capacity,
      }
      const data = {
        uuid: id,
        payload: updatePayload,
      }
      dispatch(updateInterviewSchedule(data))
        .then(action => {
          const { statusCode, success, message } = action?.payload
          if (statusCode === 200 && success) {
            dispatch(showAlert({ text: message, type: "success" }))
            navigate(-1)
          } else {
            dispatch(showAlert({ text: message, type: "error" }))
          }
        })
        .catch(error => {})
    }
    // } else {
    // First time clicking submit, show the modal
    // const startDate = formatDateForAPI(values?.start_date)
    // setNotification_message(
    //   `'لديك فترة زمنية متاحة للمقابلة في ${startDate}. يرجى تسجيل الدخول إلى حسابك لتأكيد الفترة الزمنية وحجز المقابلة.'`
    // )
    // setIsModalOpen(true)
    // }
  }

  const isPastDate = useMemo(() => {
    if (!interviewScheduleDetails) return false

    if (!interviewScheduleDetails.start_date) return false

    return moment(interviewScheduleDetails.start_date).isBefore(moment(), "day")
  }, [interviewScheduleDetails])

  return (
    <React.Fragment>
      <div className="page-content">
        {mode === "update" && loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <div className="d-flex align-items-center mb-4">
              <BackButton />
              <h4 className="card-title mb-0">
                {mode === "create"
                  ? t("Create Interview Schedule")
                  : t("Update Interview Schedule")}
              </h4>
            </div>
            <Card className="theme_card">
              <CardBody>
                <Formik
                  initialValues={formValues}
                  enableReinitialize={true}
                  validationSchema={validationSchema}
                  onSubmit={handleOnSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    isValid,
                    dirty,
                  }) => (
                    <Form>
                      <Row>
                        <Col lg={6}>
                          <div className="form_field">
                            <CustomLabel
                              htmlFor="title"
                              label={t("Title (English)")}
                              isRequired={true}
                            />
                            <CustomField
                              name="title"
                              type="text"
                              placeholder={t("Title (English)")}
                              touched={touched}
                              errors={errors}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form_field">
                            <CustomLabel
                              htmlFor="title_ar"
                              label={t("Title (Arabic)")}
                              isRequired={true}
                            />
                            <CustomField
                              name="title_ar"
                              type="text"
                              placeholder={t("Title (Arabic)")}
                              touched={touched}
                              errors={errors}
                            />
                          </div>
                        </Col>
                        <Col xs={12}>
                          <div className="form_field">
                            <CustomLabel
                              htmlFor="description"
                              label={t("Instructions (English)")}
                              // isRequired={true}
                            />
                            <ReactQuill
                              value={description}
                              onChange={setDescription}
                            />
                          </div>
                        </Col>
                        <Col xs={12}>
                          <div className="form_field">
                            <CustomLabel
                              htmlFor="description_ar"
                              label={t("Instructions (Arabic)")}
                              // isRequired={true}
                            />
                            <div
                              style={{ direction: "rtl" }}
                              className="ar_editor"
                            >
                              <ReactQuill
                                value={description_ar}
                                onChange={setDescriptionAr}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="form_field">
                            <CustomLabel
                              htmlFor="start_date"
                              label={t("Start Date")}
                              isRequired={true}
                            />
                            {/* <CustomField
                            name="start_date"
                            type="date"
                            placeholder="dd-mm-yyyy"
                            touched={touched}
                            errors={errors}
                          /> */}
                            <Flatpickr
                              options={{
                                dateFormat: "d-m-Y",
                                // minDate: "today",
                              }} // Format: dd-mm-yyyy
                              value={
                                values.start_date
                                  ? new Date(values.start_date)
                                  : ""
                              }
                              onChange={selectedDates =>
                                setFieldValue("start_date", selectedDates[0])
                              }
                              placeholder={t("Select a date")}
                              className={`form-control ${
                                errors?.start_date && touched?.start_date
                                  ? "is-invalid"
                                  : ""
                              }`}
                              disabled={mode === "update" && isPastDate}
                            />
                            <ErrorMessage
                              name={"start_date"}
                              component="div"
                              className="text-danger"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="form_field">
                            <CustomLabel
                              htmlFor="start_time"
                              label={t("Start Time")}
                              isRequired={true}
                            />
                            <CustomField
                              name="start_time"
                              type="time"
                              touched={touched}
                              errors={errors}
                              isReadOnly={mode === "update" && isPastDate}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="form_field">
                            <CustomLabel
                              htmlFor="end_date"
                              label={t("End Date")}
                              isRequired={true}
                            />
                            <Flatpickr
                              options={{
                                dateFormat: "d-m-Y",
                                minDate: values.start_date
                                  ? new Date(values.start_date)
                                  : "today", // Prevents past dates
                              }}
                              value={
                                values.end_date ? new Date(values.end_date) : ""
                              }
                              onChange={selectedDates =>
                                setFieldValue("end_date", selectedDates[0])
                              }
                              placeholder={t("Select a date")}
                              className={`form-control ${
                                errors?.end_date && touched?.end_date
                                  ? "is-invalid"
                                  : ""
                              }`}
                              disabled={
                                mode === "update" &&
                                isPastDate &&
                                !values.is_pool
                              }
                            />
                            <ErrorMessage
                              name={"end_date"}
                              component="div"
                              className="text-danger"
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="form_field">
                            <CustomLabel
                              htmlFor="end_time"
                              label={t("End Time")}
                              isRequired={true}
                            />
                            <CustomField
                              name="end_time"
                              type="time"
                              touched={touched}
                              errors={errors}
                              isReadOnly={mode === "update" && isPastDate}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form_field d-flex gap-2 align-items-center">
                            <input
                              type="checkbox"
                              checked={values.is_pool} // Use checked instead of value
                              onClick={() => {
                                if (mode === "update") {
                                  return
                                }
                                const newIsPoolValue = !values.is_pool
                                setFieldValue("is_pool", newIsPoolValue)

                                // Reset other fields when is_pool is checked
                                if (newIsPoolValue) {
                                  setFieldValue("city_ids", [])
                                  setFieldValue("gender", "")
                                  setFieldValue("specialization_ids", [])
                                  setFieldValue(
                                    "education_qualification_ids",
                                    []
                                  )
                                  setFieldValue("nationality_ids", [])
                                  setFieldValue("Nationalities", [])
                                  setFieldValue("positions_ids", [])
                                  setFieldValue("employee_experience", "")
                                  setMinAge(0)
                                  setMaxAge(0)
                                }
                                setFieldValue(
                                  "is_auto_accepted_invitation",
                                  false
                                )
                              }}
                              style={{ height: "unset", width: "unset" }}
                              className="mb-1"
                              // disabled={mode === "update"}
                            />
                            <CustomLabel
                              htmlFor="is_pool"
                              label={t("Do not notify the candidates")}
                            />
                          </div>

                          <div className="form_field d-flex gap-2 align-items-center">
                            <input
                              type="checkbox"
                              checked={values.is_auto_accepted_invitation} // Use checked instead of value
                              onClick={() => {
                                if (mode === "update") {
                                  return
                                }
                                setFieldValue(
                                  "is_auto_accepted_invitation",
                                  !values.is_auto_accepted_invitation
                                )

                                setFieldValue("is_pool", false)
                              }}
                              style={{ height: "unset", width: "unset" }}
                              className="mb-1"
                              // disabled={mode === "update"}
                            />
                            <CustomLabel
                              htmlFor="is_auto_accepted_invitation"
                              label={t("Auto accept the invite")}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form_field">
                            <CustomLabel
                              htmlFor="total_capacity"
                              label={t("Total Capacity")}
                              isRequired={true}
                            />
                            <CustomField
                              name="total_capacity"
                              type="number"
                              touched={touched}
                              errors={errors}
                              // isReadOnly={mode === "update"}
                            />
                          </div>
                        </Col>
                        {!values.is_pool && (
                          <>
                            <Col lg={6}>
                              <div className="form_field">
                                <CustomLabel
                                  htmlFor="city_ids"
                                  label={t("Cities")}
                                  // isRequired={true}
                                />
                                <Select
                                  name={values.city_ids}
                                  value={values.city_ids}
                                  isMulti={true}
                                  onChange={e => {
                                    setFieldValue("city_ids", e)
                                  }}
                                  options={dropdownData?.cities?.map(item => ({
                                    label: getLocalizedName(item, language),
                                    value: item.id,
                                  }))}
                                  className={`react-select-container`}
                                  placeholder={`${" "} ${t("Select cities")}`}
                                  closeMenuOnSelect={false}
                                  isDisabled={
                                    mode === "update" || values.is_pool
                                  }
                                />
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="form_field">
                                <CustomLabel
                                  htmlFor="gender"
                                  label={t("Gender")}
                                  // isRequired={true}
                                />
                                <CustomSingleSelect
                                  name="gender"
                                  value={genders.find(
                                    item => item.value === values.gender
                                  )}
                                  options={genders}
                                  placeholder={t("Select Gender")}
                                  onChange={e =>
                                    setFieldValue(`gender`, e?.value)
                                  }
                                  isDisabled={
                                    mode === "update" || values.is_pool
                                  }
                                />

                                <ErrorMessage
                                  name={"gender"}
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="form_field">
                                <CustomLabel
                                  htmlFor="specialization_ids"
                                  label={t("Specializations")}
                                  // isRequired={true}
                                />
                                <Select
                                  value={values.specialization_ids}
                                  isMulti
                                  onChange={e => {
                                    setFieldValue("specialization_ids", e)
                                  }}
                                  isDisabled={
                                    mode === "update" || values.is_pool
                                  }
                                  options={dropdownData?.spacialization?.map(
                                    item => ({
                                      label: getLocalizedName(item, language),
                                      value: item.id,
                                    })
                                  )}
                                  className={`react-select-container`}
                                  placeholder={`${" "} ${t(
                                    "Select Specializations"
                                  )}`}
                                  closeMenuOnSelect={false}
                                />

                                <ErrorMessage
                                  name={"specialization_ids"}
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </Col>

                            <Col lg={6}>
                              <div className="form_field">
                                <CustomLabel
                                  htmlFor="nationality_ids"
                                  label={t("Nationalities")}
                                  // isRequired={true}
                                />
                                <Select
                                  value={values.nationality_ids}
                                  isMulti
                                  onChange={e => {
                                    setFieldValue("nationality_ids", e)
                                  }}
                                  isDisabled={
                                    mode === "update" || values.is_pool
                                  }
                                  options={systemNationalities?.map(item => ({
                                    label: getLocalizedName(item, language),
                                    value: item.id,
                                  }))}
                                  className={`react-select-container`}
                                  placeholder={`${" "} ${t(
                                    "Select Nationalities"
                                  )}`}
                                  closeMenuOnSelect={false}
                                />

                                <ErrorMessage
                                  name={"nationality_ids"}
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="form_field">
                                <CustomLabel
                                  htmlFor="education_qualification_ids"
                                  label={t("Education Qualification")}
                                  // isRequired={true}
                                />
                                <Select
                                  value={values.education_qualification_ids}
                                  isMulti
                                  onChange={e => {
                                    setFieldValue(
                                      "education_qualification_ids",
                                      e
                                    )
                                  }}
                                  isDisabled={
                                    mode === "update" || values.is_pool
                                  }
                                  options={dropdownData?.education_qualifications?.map(
                                    item => ({
                                      label: getLocalizedName(item, language),
                                      value: item.id,
                                    })
                                  )}
                                  className={`react-select-container`}
                                  placeholder={`${" "} ${t(
                                    "Select Education Qualifications"
                                  )}`}
                                  closeMenuOnSelect={false}
                                />

                                <ErrorMessage
                                  name={"education_qualification_ids"}
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="form_field">
                                <CustomLabel
                                  htmlFor="employee_experience"
                                  label={t("Employee Experience")}
                                  // isRequired={true}
                                />
                                <CustomSingleSelect
                                  name="employee_experience"
                                  value={experiences.find(
                                    item =>
                                      item.value === values.employee_experience
                                  )}
                                  options={experiences}
                                  placeholder={t("Select Employee Experience")}
                                  onChange={e => {
                                    setFieldValue(
                                      `employee_experience`,
                                      e?.value
                                    )
                                  }}
                                  isDisabled={
                                    mode === "update" || values.is_pool
                                  }
                                />

                                <ErrorMessage
                                  name={"employee_experience"}
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </Col>
                            {values.employee_experience === "1" && (
                              <Col lg={6}>
                                <div className="form_field">
                                  <CustomLabel
                                    htmlFor="positions_ids"
                                    label={t("Positions")}
                                  />

                                  <Select
                                    name={values.positions_ids}
                                    value={values.positions_ids}
                                    isMulti={true}
                                    onChange={e => {
                                      setFieldValue("positions_ids", e)
                                    }}
                                    options={dropdownData?.job_titles?.map(
                                      item => ({
                                        label: getLocalizedName(item, language),
                                        value: item.id,
                                      })
                                    )}
                                    className={`react-select-container`}
                                    placeholder={`${" "} ${t(
                                      "Select positions"
                                    )}`}
                                    closeMenuOnSelect={false}
                                    isDisabled={
                                      mode === "update" || values.is_pool
                                    }
                                  />
                                </div>
                              </Col>
                            )}
                            <Col lg={6}>
                              <div className="form_field">
                                <CustomLabel
                                  htmlFor="age_gap"
                                  label={t("Age Range")}
                                />
                                <div className="d-flex gap-3">
                                  <input
                                    type="number"
                                    placeholder={t("Min")}
                                    className="form-control"
                                    value={minAge}
                                    onChange={e => setMinAge(e.target.value)}
                                    disabled={
                                      mode === "update" || values.is_pool
                                    }
                                  />
                                  <input
                                    type="number"
                                    placeholder={t("Max")}
                                    className="form-control"
                                    value={maxAge}
                                    onChange={e => setMaxAge(e.target.value)}
                                    disabled={
                                      mode === "update" || values.is_pool
                                    }
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col lg={6}>
                              <div className="form_field">
                                <CustomLabel
                                  htmlFor="national_ids"
                                  label={t("National ID / Iqama ID")}
                                />

                                <Field
                                  as="textarea"
                                  name="national_ids"
                                  className="form-control"
                                  placeholder={t(
                                    "Please enter national Id/ Iqama Id: eg. 1234657890, 2345678910"
                                  )}
                                  readOnly={mode === "update"}
                                ></Field>
                                <ErrorMessage
                                  name={"national_ids"}
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </Col>
                          </>
                        )}
                        <Col lg={6}>
                          <div className="form_field">
                            <CustomLabel htmlFor="note" label={t("Note")} />
                            <Field
                              as="textarea"
                              name="note"
                              className="form-control"
                              placeholder={t("Enter Note")}
                              maxLength={250}
                            ></Field>
                          </div>
                        </Col>
                        <Col lg={12}>
                          <div className="g_end mt-2 gap-3 cis_btn">
                            <button
                              className="main_btn disabled-button fit_content px-4"
                              type="button"
                              onClick={() => navigate(-1)}
                              disabled={isLoading}
                            >
                              {t("Cancel")}
                            </button>
                            {!values.is_pool &&
                              mode !== "update" &&
                              (showAll ||
                                permissions.includes(
                                  "can_see_matching_results"
                                )) && (
                                <button
                                  className="main_btn fit_content px-4"
                                  type="button"
                                  onClick={toggle}
                                  disabled={
                                    !isValid || !dirty || mode === "update"
                                  }
                                >
                                  {t("View Matching Candidates")}
                                </button>
                              )}
                            <button
                              className="main_btn fit_content px-4"
                              type="submit"
                              disabled={isLoading}
                            >
                              {t("Submit")}
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <Modal
                        isOpen={modal}
                        toggle={toggle}
                        className="full_screen_modal"
                        backdrop="static"
                      >
                        <ModalHeader toggle={toggle}>
                          {t("Matched Candidates List")}{" "}
                          {!loading2 && totalCount ? `(${totalCount})` : ""}
                        </ModalHeader>
                        <ModalBody className="pt-0">
                          <MatchedCandidates
                            showAll={showAll}
                            permissions={permissions}
                            values={{ ...values, minAge, maxAge }}
                            selectedCandidates={selectedCandidates}
                            setSelectedCandidates={setSelectedCandidates}
                            selectAllPages={selectAllPages}
                            setSelectAllPages={setSelectAllPages}
                            selectCurrentPage={selectCurrentPage}
                            setSelectCurrentPage={setSelectCurrentPage}
                            uncheckedIds={uncheckedIds}
                            setUncheckedIds={setUncheckedIds}
                          />
                        </ModalBody>
                        {/* <ModalFooter>
                        <Button color="secondary" onClick={toggle}>
                          Close
                        </Button>
                      </ModalFooter> */}
                      </Modal>

                      <Modal
                        isOpen={isModalOpen}
                        toggle={toggleModal}
                        backdrop="static"
                      >
                        <ModalHeader toggle={toggleModal}>
                          {t("Notification Message")}
                        </ModalHeader>
                        <ModalBody>
                          <textarea
                            className="form-control"
                            value={notification_message}
                            onChange={
                              e =>
                                setNotification_message(
                                  e.target.value.slice(0, 1500)
                                ) // Limit 255 chars
                            }
                            maxLength={1500}
                          />
                          <div className="d-flex justify-content-end align-items-center fs-6 mt-2">
                            {notification_message?.length}/1500
                          </div>
                        </ModalBody>
                        <ModalFooter>
                          <Button color="secondary" onClick={toggleModal}>
                            {t("Cancel")}
                          </Button>
                          <Button
                            color="primary"
                            onClick={() => {
                              handleOnSubmit(values)
                            }}
                            disabled={!notification_message.trim()} // Disable if empty
                          >
                            {t("Confirm")}
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Container>
        )}
      </div>
    </React.Fragment>
  )
}

export default CreateInterviewSchedule
